import React, {useState} from 'react';
import Navigation from '../../components/navigation'
import Banner from '../../components/banner'
import Footer from '../../components/footer'
import CompanySelector from '../../components/company-selector'
import pic1 from "../../public/images/job/job-pic-1.png";
function App() {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        position: '',
        experience: '',
        education: '',
        resume: null,
        coverLetter: ''
    });

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        setFormData(prev => ({
            ...prev,
            resume: e.target.files[0]
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // 这里可以添加表单提交逻辑
        alert('简历投递成功！我们会尽快与您联系。');
    };

    return (
        <div className="app">
            <Navigation active={2}/>
            <Banner/>
            <div className="main-container">
                <div className="main-inner">
                    <img className={'pic-1'} src={pic1} alt="" />
                    <CompanySelector/>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default App;